import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';

import { notificationsActions, useAppDispatch } from '@modules';

import InfoContent from '@containers/InfoContent';
import WalletSendLayoutOld from '@layouts/WalletSendLayoutOld';

import Illustration from './Illustration';

import style from './SendToBankAccount.scss';

const cn = bemCssModules(style, 'SendToBankAccount');

export const SendToBankAccount: CustomFC = () => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleClickButton = () => {
    dispatch(
      notificationsActions.add({
        title: t('notifications.title.great'),
        message: t('notifications.descr.let_know'),
      })
    );
  };
  return (
    <WalletSendLayoutOld>
      <InfoContent
        className={cn('info')}
        title={t('withdraw.send_bank_account')}
        buttonText={t('withdraw.button.notify')}
        onClickButton={handleClickButton}
      >
        <Illustration />
      </InfoContent>
    </WalletSendLayoutOld>
  );
};

export default SendToBankAccount;
